import * as React from 'react';
import { Balloon } from '@alifd/next';

export default function Index ( props: any ) {
    const { i18n,seller } = props;

    const { homeUrl,companyLogoFileUrlSmall,companyName } = seller;
    const renderItem = () => {
        const items = []
        for ( let index = 1; index < 4; index++ ) {
            items.push( <Balloon
                trigger={
                    <li className="promise-list-li">
                        <img src={i18n[`companyCardIntegrated.self.promiselist.${index}.logo`]} alt="avtar" />
                        <span>{i18n[`companyCardIntegrated.self.promiselist.${index}.text`]}</span>
                    </li>
                }
                key={index}
                closable={false}
                align="bl"
                alignEdge
                offset={[-5,0]}
                cache
                popupContainer={() =>
                    document.querySelector( '#seller-self-operated-card' )
                }
                className="promise-list-li-balloon"
                style={{
                    maxWidth: '232px',
                    background: '#FAFAFA',
                    color: '#333',
                }}
            >
                {i18n[`companyCardIntegrated.self.promiselist.${index}.balloonText`]}
            </Balloon> )
        }
        return items;
    }
    return (
        <div id="seller-self-operated-card">
            <div className="alibaba-shop-card">
                <div className="offical-name-and-photo">
                    <img
                        src={companyLogoFileUrlSmall}
                        alt="avtar"
                        className="offical-photo"
                    />
                    <a className="offical-name" target="_blank" href={homeUrl} data-aui="company-name" data-domdot="id:3317">
                        {companyName}
                    </a>
                </div>
                <div className="split-line" />
                <div className="we-promise">
                    {i18n['companyCardIntegrated.self.promise']}
                </div>
                <div className="promise-list">
                    <ul className="promise-list-ul">
                        {renderItem()}
                    </ul>
                </div>
            </div>
        </div>
    )
}